import { animate, state, style, transition, trigger } from '@angular/animations';

export const animateHeight = trigger('animateHeight', [
  state(
    'maximized',
    style({
      height: '200px',
    }),
  ),
  state(
    'minimized',
    style({
      height: '48px',
    }),
  ),
  transition('maximized <=> minimized', [animate('0.3s ease-in-out')]),
]);

export const slideAnimation = trigger('slideAnimation', [
  transition(':increment', [
    style({ transform: 'translateX(100%)' }),
    animate('300ms ease-in-out', style({ transform: 'translateX(0)' })),
  ]),
  transition(':decrement', [
    style({ transform: 'translateX(-100%)' }),
    animate('300ms ease-in-out', style({ transform: 'translateX(0)' })),
  ]),
]);

export const onSideNavChange = trigger('onSideNavChange', [
  state(
    'close',
    style({
      width: '64px',
    }),
  ),
  state(
    'open',
    style({
      width: '256px',
    }),
  ),
  transition('close => open', animate('250ms cubic-bezier(.93,.01,.22,1)')),
  transition('open => close', animate('250ms cubic-bezier(.93,.01,.22,1)')),
]);

export const slideInOut = trigger('slideInOut', [
  state(
    'in',
    style({
      height: '*',
      opacity: '1',
      visibility: 'visible',
      overflow: 'auto',
    }),
  ),
  state(
    'out',
    style({
      height: '0',
      opacity: '0',
      visibility: 'hidden',
      overflow: 'hidden',
    }),
  ),
  transition('out => in', [
    style({ height: '0', opacity: 0 }), // Start collapsed
    animate('0.4s ease-in-out', style({ height: '*', opacity: 1 })), // Expand fully
  ]),
  transition('in => out', [
    style({ height: '*', opacity: 1 }), // Start expanded
    animate('0.4s ease-in-out', style({ height: '0', opacity: 0 })), // Collapse fully
  ]),
]);

export const animateText = trigger('animateText', [
  state(
    'hide',
    style({
      opacity: 0,
    }),
  ),
  state(
    'show',
    style({
      opacity: 1,
    }),
  ),
  transition('close => open', animate('550ms ease-in')),
  transition('open => close', animate('550ms ease-out')),
]);
